<div class="tw-bg-gradient-peach-to-light-peach tw-rounded-t-[25px] tw-font-body tw-relative">
  <div
    type="button"
    class="tw-absolute tw-right-5 tw-top-[21px] tw-w-6 tw-aspect-square tw-flex tw-items-center tw-justify-center"
    aria-label="Close"
    (click)="closeBottomSheet()"
  >
    <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-700" [iconName]="'close'"></cs-icon>
  </div>

  <div class="tw-p-6 tw-pb-9" [ngClass]="{'tw-pt-[47px]': data.userInitialImagePath?.length > 1}">
      @if(data.userInitialImagePath?.length > 1){
        <div class="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-mb-[31px]">

          <div class="tw-h-[104px] tw-aspect-square tw-rounded-[12px] tw-overflow-hidden tw-bg-white tw-flex tw-items-center tw-justify-center tw-p-0.5 tw-relative">
            <div class="tw-absolute tw-w-9 tw-h-3 tw-bg-white tw-text-teal-600 tw-font-[700] tw-flex tw-justify-center tw-items-center tw-rounded-b-1 tw-top-0 tw-text-25 tw-z-10">
              DAY 0
            </div>
            <ng-container *ngIf="data.userInitialImagePath">
              <img
                [src]="data.userInitialImagePath"
                alt="Initial checkup"
                class="tw-h-full tw-w-full tw-object-cover tw-rounded-[10px] tw-grayscale"
              />
            </ng-container>
          </div>

          <div class="tw-text-gray-400 tw-text-600 tw-font-bold">
            <cs-icon class="tw-w-[11px] tw-text-gray-700" [iconName]="'small-right-arrow'"></cs-icon>
          </div>

          <div class="tw-h-[104px] tw-aspect-square tw-rounded-[12px] tw-overflow-hidden tw-bg-white tw-flex tw-items-center tw-justify-center tw-p-0.5 tw-relative tw-border tw-border-dashed tw-border-orange-200 tw-shadow-z13">
            <div class="tw-absolute tw-w-9 tw-h-3 tw-bg-teal-400 tw-text-white tw-font-[700] tw-flex tw-justify-center tw-items-center tw-rounded-b-1 tw-top-0 tw-text-25 tw-z-10">
              DAY {{ data.daysSinceRegimenDelivery ?? 0 }}
            </div>
            <cs-icon class="tw-w-10 tw-aspect-square tw-text-gray-700" [iconName]="'add-image-icon'"></cs-icon>
          </div>
        </div>
      } @else {
        <div>
          <img src="/assets/images/calendar.png" id="calendar" class="tw-w-[164px] tw-mix-blend-multiply tw-mx-auto">
        </div>
      }



    <h2 i18n="@@checkupPersonalisedNudgeBackTitle" class="tw-text-center tw-font-bold tw-text-650 tw-leading-tight tw-mb-2 tw-font-lexend tw-px-7">
      {{ data.userFirstName }}, it&#39;s time for your checkup
    </h2>
    <p i18n="@@checkupPersonalisedNudgeBackDescription" class="tw-text-center tw-text-gray-500 tw-text-300 tw-leading-5 tw-mb-10">
      Share updated photos so your doctor can assess your progress and send your report.
    </p>

    <button csButton
            (click)="takeCheckupNow()"
            class="tw-min-w-fit tw-w-full tw-px-10 tw-mx-auto">
      <span i18n="@@checkupPersonalisedNudgeBackCta" class="tw-text-500 tw-font-semibold tw-font-lexend">Take Checkup Now</span>
    </button>

    <button
      type="button"
      class="tw-w-full tw-text-center tw-text-teal-600 tw-font-bold tw-text-400 tw-font-lexend"
      (click)="skip()"
      i18n="@@skip">Skip</button>
  </div>
</div>


